import { MenuProps } from './types';
import { Popover, PopoverContent, PopoverTrigger } from '@components/ui/popover';
import { MenuItem } from './item';
import { MenuHeader } from './header';
import { Fragment, SyntheticEvent } from 'react';
import { cn } from '@utils/cn';

const DISABLE_SCROLL = true;

export const Menu = ({
  options,
  children,
  variant = 'big',
  open,
  setOpen,
  popoverRef,
  contentClassName,
}: MenuProps) => {
  const handleItemClick = (e: SyntheticEvent<HTMLButtonElement>, callback: () => void) => {
    e.stopPropagation();
    setOpen(false);
    callback();
  };

  return (
    <Popover modal={DISABLE_SCROLL} open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        container={popoverRef?.current}
        align="end"
        className={cn(
          'scrollbar-thin relative left-0 z-[60] flex max-h-[250px] w-fit max-w-[205px] flex-col overflow-hidden overflow-y-auto rounded border-none p-0 text-xs shadow-stage-menu',
          contentClassName,
        )}>
        {options.map(({ group, items }) => (
          <Fragment key={group.id}>
            {group?.name && <MenuHeader>{group.name}</MenuHeader>}
            {items.map(({ id, name, callback }) => (
              <MenuItem key={id} onClick={(e) => handleItemClick(e, callback)} variant={variant}>
                {name}
              </MenuItem>
            ))}
          </Fragment>
        ))}
      </PopoverContent>
    </Popover>
  );
};
